import('./assets/less/app.less')
import Vue from 'vue'
import { mapActions } from 'vuex'

import App from './app.vue'
import store from './store/index'
import router from './router/index'

import { forIn, trim, time2text, truncate } from './utils/xp.v1'
import components from './components/index.js'

// filters
forIn(
  {
    trim,
    time2text,
    truncate
  },
  (fn, key) => Vue.filter(key, fn)
)

Vue.use(components)

window.wzWebApp = new Vue({
  router,
  store,
  el: '#webApp',
  render: (h) => h(App),
  computed: {},
  methods: {
    ...mapActions('account', ['loadAccount']),
    ...mapActions('reddot', ['loadRedDot', 'clearRedDot']),

    // 检测是否已发放奖励
    chkReddot(item) {
      this.loadRedDot({ items: item }).then((map) => {
        const R = map[item]
        if ((R && R.num > 0)) {
          this.$dialog
            .confirm({
              title: '奖励发放啦',
              message: '【我的软件】内查看使用有效期，<br>赶快去体验吧！',
              cancelButtonText: '稍后再看',
              confirmButtonText: '前往查看'
            })
            .then(
              async () => {
                await this.clearRedDot({ item })
                location.href = '/award2020/dianjin/list'
              },
              () => this.clearRedDot({ item })
            )
        }
      })
    },

    init() {
      this.loadAccount()
      this.chkReddot(13)
    },
    destroy() {
      // this.timerStop()
    }
  },
  async created() {
    this.init()
  },
  beforeDestroy() {
    this.destroy()
  }
})
